import { render, staticRenderFns } from "./TheAccountView.vue?vue&type=template&id=9a753014"
import script from "./TheAccountView.vue?vue&type=script&lang=js"
export * from "./TheAccountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports